module.exports = __webpack_public_path__ + "fronted/src/img/voice3.10655248.png";